module.exports = __webpack_public_path__ + "img/logo_lh.7efc2037.png";